<mat-dialog-content>
  <h1 mat-dialog-title>
    {{ (this.data.type == 'section' ? 'Global.RearrangeSections' : 'Global.RearrangeLectures') | translate }}
  </h1>
  <div class="p-dsplyr-bx result-box" cdkDropList #progressList="cdkDropList" [cdkDropListData]="elements" [id]="'contentSorter'" (cdkDropListDropped)="drop($event)">
    <div class="result-box">
      @for (element of elements; track element) {
        <mat-card appearance="outlined" class="p-dsplyr-item drag-item" cdkDrag>
          <mat-card-content class="p-0">
            <div class="body">{{ element.actualName }}</div>
          </mat-card-content>
        </mat-card>
      }
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="dialog-actions">
  <button mat-flat-button color="accent" (click)="cancel()">
    {{ 'Confirm.Cancel' | translate }}
  </button>
  <button mat-flat-button color="primary" (click)="save()">
    {{ 'Global.Save' | translate }}
  </button>
</mat-dialog-actions>
